import { Component, OnInit, ViewChild } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from "@angular/material/sidenav";
import { MediaObserver, MediaChange } from "@ngbracket/ngx-layout";
import { TenantMath } from "src/app/craidd/modelau/defnyddiwr/rol";
import { DeviceDetectorService } from "ngx-device-detector";
import { DilysuService } from "src/app/craidd/gwasanaethau/defnyddiwr/dilysu.service";
import { SidenavService } from "src/app/craidd/gwasanaethau/system/sidenav.service";
import { filter, map, startWith } from "rxjs/operators";
import { StorfaDefnyddiwrService } from "src/app/craidd/gwasanaethau/system/storfa-defnyddiwr.service";
import { SidebarDewislenComponent } from "../sidebar-dewislen/sidebar-dewislen.component";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { HawlfraintComponent } from "../hawlfraint/hawlfraint.component";
import { NavbarComponent } from "../navbar/navbar.component";
import { RhybuddComponent } from "../../rhybudd/rhybudd/rhybudd.component";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
    imports: [
        MatSidenavContainer,
        MatSidenav,
        SidebarDewislenComponent,
        FaIconComponent,
        HawlfraintComponent,
        MatSidenavContent,
        NavbarComponent,
        RhybuddComponent,
        RouterOutlet,
    ],
})
export class SidebarComponent implements OnInit {
  @ViewChild("sidenav") public sidenav: MatSidenav;

  opened = true;
  over = "side";
  displayMode = "flat";

  watcher: Subscription;

  wediCau: boolean;

  enwTenant$: Observable<string>;
  enwTenant: string = "";

  constructor(
    private dilysuService: DilysuService,
    mediaObserver: MediaObserver,
    private deviceService: DeviceDetectorService,
    private sidenavService: SidenavService,
    private storfaDefnyddiwrService: StorfaDefnyddiwrService,
  ) {
    // https://www.npmjs.com/package/ngx-device-detector
    const isTablet = this.deviceService.isTablet();

    if (isTablet) {
      this.opened = false;
      this.over = "over";
    } else {
      this.watcher = mediaObserver
        .asObservable()
        .pipe(
          filter((changes: MediaChange[]) => changes.length > 0),
          map((changes: MediaChange[]) => changes[0]),
        )
        .subscribe((change: MediaChange) => {
          if (change.mqAlias === "sm" || change.mqAlias === "xs") {
            this.opened = false;
            this.over = "over";
          } else {
            this.opened = true;
            this.over = "side";
          }
        });
    }
  }

  ngOnInit() {
    this.enwTenant$ = this.storfaDefnyddiwrService.storfaDefnyddiwr$.pipe(
      startWith(true),
      map(() => this.storfaDefnyddiwrService.nolEnwTenant()),
    );

    this.enwTenant$.subscribe((tenant) => {
      this.enwTenant = tenant;
    });

    this.sidenavService.sideNavToggleSubject.subscribe(() => {
      if (this.sidenav) {
        this.sidenav.toggle();
      }
    });
  }

  allgofnodi() {
    this.dilysuService.allgofnodi();
  }

  wediMewngofnodi() {
    return this.dilysuService.wediMewngofnodi();
  }

  agorCauDewislen(): void {
    if (this.wediCau) {
      this.wediCau = false;
    } else {
      this.wediCau = true;
    }
  }

  cssClass(): string {
    if (this.wediCau) {
      return "mat-sidenav-bach";
    }

    return "";
  }

  cssCefndirLogo(): string {
    switch (this.enwTenant) {
      case TenantMath.Gwynedd:
        return "mat-sidenav-teitl";
      case TenantMath.PriffyrddGwynedd:
        return "mat-sidenav-teitl";
      case TenantMath.Fflint:
        return "mat-sidenav-teitl-fflint";
      case TenantMath.FflintSmallPlant:
        return "mat-sidenav-teitl-fflint";
      case TenantMath.Conwy:
        return "mat-sidenav-teitl-conwy";
      default:
        return "mat-sidenav-teitl";
    }
  }
}
